/**
 * @file   src\components\Introduction\AcceptedSendIntroductionList.js
 * @brief  This file is responsible for the view of the introduction card that was sent to the want ad users.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import _ from "lodash";
import IntroductionData from "./IntroductionData";
import IntroStatusLine from "@/components/IntroStatusLine";
import { useNavigate } from "react-router";

const AcceptedSendIntroductionList = (props) => {
  const { list, count, updateIntroPageOnScroll, ViewWantAd } = props;

  // Scroll reference
  const scrollRef = useRef(null);
  // Navigate object creation.
  const navigate = useNavigate();

  // To handle introduction list scroll for pagination
  const handleScroll = () => {
    const el = scrollRef.current;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    if (
      scrollHeight !== clientHeight &&
      scrollTop !== 0 &&
      Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
    ) {
      const section = "accepted";
      updateIntroPageOnScroll(section);
    }
  };

  return (
    <>
      {count > 0 && (
        <div className="intro-list-sec">
          <div className="title-sec">
            <h5>
              Accepted <span>({count})</span>
            </h5>
          </div>
          <div
            className="property-block-scroll"
            onScroll={handleScroll}
            ref={scrollRef}
          >
            {list.map((intro) => {
              const introId = _.get(intro, "IntroductionId", "");
              return (
                <div className="property-block" key={introId}>
                  <div
                    className="property-info property-info-hoverstyling"
                    onClick={() => {
                      if (_.get(intro, "IsExpired", "") != 1) {
                        ViewWantAd(introId);
                      }
                    }}
                  >
                    <IntroductionData introList={intro} />
                    <IntroStatusLine status={props.statusById?.[introId]} />
                  </div>
                  {_.get(intro, "IsExpired", "") != 1 ? (
                    <div className="property-action flex-shrink-0">
                      <Button
                        variant="outline"
                        className="btn-outline-primary"
                        onClick={() => navigate("/messages")}
                      >
                        Message
                      </Button>
                    </div>
                  ) : (
                    <div className="property-action drop-pos-fix flex-shrink-0 modal-wrap-label-orange f-size-14 me-0">
                      Expired
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
export default AcceptedSendIntroductionList;
